export default function Msg({ color='var(--accent)', ...props }) {
	return <svg width="10" height="9" {...props} viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.7 2.82258H8.3M1.7 5.14516H8.3M1.7 7.46774H1.5C0.947715 7.46774 0.5 7.02003 0.5 6.46774V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H8.5C9.05229 0.5 9.5 0.947715 9.5 1.5V6.46774C9.5 7.02003 9.05229 7.46774 8.5 7.46774H4.4L3.30137 8.29466C2.64236 8.7907 1.7 8.32053 1.7 7.4957V7.46774Z"
			stroke={color}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
}